module.exports = __webpack_public_path__ + "img/check-text.927d58c9.svg";